import { request, ROOT_URL } from './factory/Siprec'

export default {
  getList (options = {}) {
    return request({
      url: `${ROOT_URL}/reports/recording`,
      method: 'POST',
      data: options
    }).then(response => response.data)
  }
}




// WEBPACK FOOTER //
// ./src/models/TargetsReport.js